import { SvgIcon, SvgIconProps } from '@material-ui/core';

import React from 'react';

export const SlackIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="60 60 150 150" xmlSpace="preserve">
    <g>
      <g>
        <path
          fill="#E01E5A"
          d="M99.4,151.2c0,7.1-5.8,12.9-12.9,12.9c-7.1,0-12.9-5.8-12.9-12.9c0-7.1,5.8-12.9,12.9-12.9h12.9V151.2z"
        />
        <path
          fill="#E01E5A"
          d="M105.9,151.2c0-7.1,5.8-12.9,12.9-12.9s12.9,5.8,12.9,12.9v32.3c0,7.1-5.8,12.9-12.9,12.9
			s-12.9-5.8-12.9-12.9V151.2z"
        />
      </g>
      <g>
        <path
          fill="#36C5F0"
          d="M118.8,99.4c-7.1,0-12.9-5.8-12.9-12.9c0-7.1,5.8-12.9,12.9-12.9s12.9,5.8,12.9,12.9v12.9H118.8z"
        />
        <path
          fill="#36C5F0"
          d="M118.8,105.9c7.1,0,12.9,5.8,12.9,12.9s-5.8,12.9-12.9,12.9H86.5c-7.1,0-12.9-5.8-12.9-12.9
			s5.8-12.9,12.9-12.9H118.8z"
        />
      </g>
      <g>
        <path
          fill="#2EB67D"
          d="M170.6,118.8c0-7.1,5.8-12.9,12.9-12.9c7.1,0,12.9,5.8,12.9,12.9s-5.8,12.9-12.9,12.9h-12.9V118.8z"
        />
        <path
          fill="#2EB67D"
          d="M164.1,118.8c0,7.1-5.8,12.9-12.9,12.9c-7.1,0-12.9-5.8-12.9-12.9V86.5c0-7.1,5.8-12.9,12.9-12.9
			c7.1,0,12.9,5.8,12.9,12.9V118.8z"
        />
      </g>
      <g>
        <path
          fill="#ECB22E"
          d="M151.2,170.6c7.1,0,12.9,5.8,12.9,12.9c0,7.1-5.8,12.9-12.9,12.9c-7.1,0-12.9-5.8-12.9-12.9v-12.9H151.2z"
        />
        <path
          fill="#ECB22E"
          d="M151.2,164.1c-7.1,0-12.9-5.8-12.9-12.9c0-7.1,5.8-12.9,12.9-12.9h32.3c7.1,0,12.9,5.8,12.9,12.9
			c0,7.1-5.8,12.9-12.9,12.9H151.2z"
        />
      </g>
    </g>
  </SvgIcon>
);

export const GitLabIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="60 60 230 230">
    <g id="LOGO">
      <path
        fill="#e24329"
        d="M282.83,170.73l-.27-.69-26.14-68.22a6.81,6.81,0,0,0-2.69-3.24,7,7,0,0,0-8,.43,7,7,0,0,0-2.32,3.52l-17.65,54H154.29l-17.65-54A6.86,6.86,0,0,0,134.32,99a7,7,0,0,0-8-.43,6.87,6.87,0,0,0-2.69,3.24L97.44,170l-.26.69a48.54,48.54,0,0,0,16.1,56.1l.09.07.24.17,39.82,29.82,19.7,14.91,12,9.06a8.07,8.07,0,0,0,9.76,0l12-9.06,19.7-14.91,40.06-30,.1-.08A48.56,48.56,0,0,0,282.83,170.73Z"
      />
      <path
        fill="#fc6d26"
        d="M282.83,170.73l-.27-.69a88.3,88.3,0,0,0-35.15,15.8L190,229.25c19.55,14.79,36.57,27.64,36.57,27.64l40.06-30,.1-.08A48.56,48.56,0,0,0,282.83,170.73Z"
      />
      <path
        fill="#fca326"
        d="M153.43,256.89l19.7,14.91,12,9.06a8.07,8.07,0,0,0,9.76,0l12-9.06,19.7-14.91S209.55,244,190,229.25C170.45,244,153.43,256.89,153.43,256.89Z"
      />
      <path
        fill="#fc6d26"
        d="M132.58,185.84A88.19,88.19,0,0,0,97.44,170l-.26.69a48.54,48.54,0,0,0,16.1,56.1l.09.07.24.17,39.82,29.82s17-12.85,36.57-27.64Z"
      />
    </g>
  </SvgIcon>
);

export const JenkinsIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 275 275" xmlSpace="preserve">
    <g id="g10" transform="matrix(1.25,0,0,-1.25,0,312)">
      <g id="g3393">
        <path
          d="m 177.718,129.264 c 0,-49.4288 -39.175,-89.4992 -87.5,-89.4992 -48.3242,0 -87.49925,40.0704 -87.49925,89.4992 0,49.43 39.17505,89.501 87.49925,89.501 48.325,0 87.5,-40.071 87.5,-89.501"
          fill="#d33833"
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
          id="path22"
        />
        <path
          d="m 6.28438,107.098 c 0,0 -6.33438,93.333 79.66602,96 l -5.9996,10 -46.6664,-15.667 -13.3336,-15.333 -11.66642,-22.334 -6.66719,-26 2,-17.333"
          fill="#ef3d3a"
          fillOpacity={1}
          fillRule="nonzero"
          stroke="none"
          id="path24"
        />
        <path
          d="M 30.2883,190.319 C 14.9363,174.611 5.43633,152.923 5.43633,128.93 l 0,0 c 0,-23.988 9.49997,-45.6788 24.85197,-61.3839 l 0,0 C 45.6477,51.841 66.8152,42.15 90.2168,42.15 l 0,0 c 23.4022,0 44.5712,9.691 59.9292,25.3961 l 0,0 c 15.351,15.7051 24.853,37.3959 24.853,61.3839 l 0,0 c 0,23.993 -9.502,45.681 -24.853,61.389 l 0,0 c -15.358,15.702 -36.527,25.393 -59.9292,25.395 l 0,0 C 66.8152,215.712 45.6477,206.021 30.2883,190.319 l 0,0 z M 26.4023,63.7469 C 10.0867,80.4328 0,103.493 0,128.93 l 0,0 c 0,25.441 10.0867,48.499 26.4023,65.186 l 0,0 c 16.3118,16.69 38.8915,27.035 63.8145,27.032 l 0,0 c 24.9232,0.003 47.5052,-10.342 63.8142,-27.032 l 0,0 c 16.317,-16.687 26.405,-39.747 26.403,-65.186 l 0,0 c 0.002,-25.437 -10.086,-48.4972 -26.403,-65.1831 l 0,0 C 137.722,47.0578 115.14,36.7141 90.2168,36.7141 l 0,0 c -24.923,0 -47.5027,10.3437 -63.8145,27.0328 l 0,0"
          fill="#231f20"
          fillOpacity={1}
          fillRule="nonzero"
          stroke="none"
          id="path26"
        />
        <path
          d="m 127.051,128.768 -13.334,-2 -18.0002,-2 -11.6672,-0.333 -11.3328,0.333 -8.6672,2.667 -7.6668,8.333 -6,17 -1.3332,3.667 -8,2.666 -4.6668,7.667 -3.3332,11 3.6672,9.667 8.666,3 7,-3.334 3.334,-7.333 4,0.667 1.3328,1.666 -1.3328,7.667 -0.334,9.667 2,13.333 -0.0781,7.616 6.0781,9.717 10.6668,7.667 18.6672,8 20.6662,-3 18,-13 8.334,-13.333 5.333,-9.667 1.333,-24 -4,-20.667 -7.333,-18.333 -7,-9.667"
          fill="#f0d6b7"
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
          id="path28"
        />
        <path
          d="m 115.717,71.102 -47.6674,-2 0,-8 4,-28 -2,-2.334 -33.3328,11.334 -2.334,4 -3.3332,37.666 -7.6656,22.667 -1.6672,5.333 26.666,18.333 8.334,3.334 7.3328,-9 6.3332,-5.667 7.334,-2.333 3.3328,-1 4,-17.333 3,-3.6668 7.6672,2.6668 -5.334,-10.334 29.0002,-13.666 -3.666,-2"
          fill="#335061"
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
          id="path30"
        />
        <path
          d="m 36.7168,187.435 8.666,3 7,-3.334 3.334,-7.333 4,0.667 1,4 -2,7.666 2,18.334 -1.6672,10 6,7 13,10.333 -3.6668,5 -18.3332,-9 -7.6668,-6 -4.3332,-9.333 -6.6668,-9 -2,-10.667 1.334,-11.333"
          fill="#6d6b6d"
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
          id="path32"
        />
        <path
          d="m 50.3828,218.768 c 0,0 5,12.333 25,18.333 20,6 1,4.334 1,4.334 l -21.666,-8.334 -8.334,-8.333 -3.666,-6.667 7.666,0.667"
          fill="#dcd9d8"
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
          id="path34"
        />
        <path
          d="m 40.3828,189.768 c 0,0 -7,23.334 19.6668,26.667 l -1,4 -18.3328,-4.334 -5.334,-17.333 1.334,-11.333 3.666,2.333"
          fill="#dcd9d8"
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
          id="path36"
        />
        <path
          d="m 51.0496,158.768 4.3645,4.229 c 0,0 1.9699,-0.229 2.3027,-2.562 0.3328,-2.334 1.3328,-23.334 15.666,-34.668 1.3074,-1.034 -10.666,1.668 -10.666,1.668 l -10.6672,16.666"
          fill="#f7e4cd"
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
          id="path38"
        />
        <path
          d="m 112.385,165.101 c 0,0 0.777,10.104 3.498,9.327 2.721,-0.777 2.721,-3.498 2.721,-3.498 0,0 -6.608,-4.275 -6.219,-5.829"
          fill="#f7e4cd"
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
          id="path40"
        />
        <path
          d="m 140.05,202.101 c 0,0 -5.494,-1.16 -6,-6 -0.506,-4.841 6,-1 7,-0.667"
          fill="#f7e4cd"
          fillOpacity={1}
          fillRule="nonzero"
          stroke="none"
          id="path42"
        />
        <path
          d="m 99.7168,201.767 c 0,0 -7.334,-1 -7.334,-5.666 0,-4.667 8.3342,-4.334 10.6672,-2.334"
          fill="#f7e4cd"
          fillOpacity={1}
          fillRule="nonzero"
          stroke="none"
          id="path44"
        />
        <path
          d="m 54.3828,180.101 c 0,0 -12.6672,7.667 -14,0.333 -1.3332,-7.333 -4.334,-12.667 2,-20.333 l -4.3332,1.333 -4,10.333 -1.3328,10 7.666,8.001 8.6668,-0.667 5,-4 0.3332,-5"
          fill="#f7e4cd"
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
          id="path46"
        />
        <path
          d="m 60.3828,201.101 c 0,0 5.6668,29.333 34.334,35 23.6012,4.665 35.9992,-1 40.6662,-6.333 0,0 -21,24.999 -41.0002,17.333 -20,-7.667 -34.666,-21.667 -34.3332,-30.666 0.5676,-15.328 0.3332,-15.334 0.3332,-15.334"
          fill="#f7e4cd"
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
          id="path48"
        />
        <path
          d="m 137.717,226.435 c 0,0 -9.666,0.333 -10,-8.334 0,0 -0.001,-1.333 0.666,-2.666 0,0 7.668,8.667 12.334,4"
          fill="#f7e4cd"
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
          id="path50"
        />
        <path
          d="m 95.3887,214.532 c 0,0 -1.6641,13.303 -13.0059,5.569 -7.3332,-5 -6.666,-12 -5.3332,-13.333 1.3332,-1.334 0.9707,-4.019 1.9856,-2.176 1.0144,1.843 0.6804,7.843 4.3476,9.509 3.6668,1.667 9.6777,3.529 12.0059,0.431"
          fill="#f7e4cd"
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
          id="path52"
        />
        <path
          d="m 64.0496,124.435 -31.3328,-14 c 0,0 13,-51.667 6.3328,-67.667 l -4.6668,1.666 -0.3332,19.6672 -8.6656,37.3328 -3.6672,10.334 32.666,21.999 9.6668,-9.332"
          fill="#49728b"
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
          id="path54"
        />
        <path
          d="m 67.2715,95.8578 4.4453,-5.4238 0,-20 -5.334,0 c 0,0 -0.666,14 -0.666,15.6672 0,1.6668 0.666,7.6668 0.666,7.6668"
          fill="#49728b"
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
          id="path56"
        />
        <path
          d="m 67.3828,67.434 -15,-0.666 4.334,-3 10.666,-1.6668"
          fill="#49728b"
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
          id="path58"
        />
        <path
          d="m 118.717,70.768 12.333,0.3332 3,-30.6672 -12.667,-1.666 -2.666,32"
          fill="#335061"
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
          id="path60"
        />
        <path
          d="m 122.05,70.768 18.667,1 c 0,0 7.666,19.3332 7.666,20.3332 0,1 6.667,27.9998 6.667,27.9998 l -15,15.666 -3,2.667 -8,-8 0,-31 -7,-28.666"
          fill="#335061"
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
          id="path62"
        />
        <path
          d="m 130.383,73.1012 -11.666,-2.3332 1.666,-9.334 c 4.333,-2 11.667,3.334 11.667,3.334"
          fill="#49728b"
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
          id="path64"
        />
        <path
          d="m 130.717,131.434 23.333,-17.333 0.667,8 -17.667,16.333 -6.333,-7"
          fill="#49728b"
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
          id="path66"
        />
        <path
          d="M 78.9508,5.09805 72.0496,33.102 68.6172,53.7648 68.0496,69.102 l 31.2348,1.6628 19.4326,0.0032 -1.767,-35.0032 3,-26.99996 -0.333,-5 -25.3326,-2 -15.3336,3.33321"
          fill="#ffffff"
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
          id="path68"
        />
        <path
          d="m 114.383,71.1012 c 0,0 -1.666,-34.6672 3.334,-59.3332 0,0 -10,-6.33402 -24.6674,-8.00003 l 28.0004,1 3.333,2 -4,54.66603 -1,11.668"
          fill="#dcd9d8"
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
          id="path70"
        />
        <path
          d="m 134.618,43.098 13,3.6668 24.666,1.3332 3.667,11.3329 -6.667,19.6671 -7.666,1 -10.667,-3.3332 -10.234,-4.9968 -5.433,0.9968 -4.234,-1.6636"
          fill="#ffffff"
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
          id="path72"
        />
        <path
          d="m 134.383,49.768 c 0,0 8.666,3.9992 10,3.666 l -3.666,18.334 4.333,1.666 c 0,0 3,-17.3328 3,-19.3328 0,0 18.666,-1 20.333,-1 0,0 4,7.6668 3,15.6668 l 3.667,-10.6668 0.333,-6 -5.333,-8 -6,-1.3332 -10,0.3332 -3.333,4.3328 -11.667,-1.666 -3.667,-1.334"
          fill="#dcd9d8"
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
          id="path74"
        />
        <path
          d="m 121.284,73.4309 -7.333,18.6671 -7.667,11 c 0,0 1.666,4.667 4,4.667 2.334,0 7.667,0 7.667,0 l 7.333,-2.667 -0.666,-12.3332 -3.334,-19.3339"
          fill="#ffffff"
          fillOpacity={1}
          fillRule="nonzero"
          stroke="none"
          id="path76"
        />
        <path
          d="m 122.717,79.768 c 0,0 -9.334,17.9992 -9.334,20.666 0,0 1.666,4 4,3 2.334,-1 7.334,-3.666 7.334,-3.666 l 0,6.333 -11.334,2.334 -7.666,-1 13,-30.667 2.666,-0.334"
          fill="#dcd9d8"
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
          id="path78"
        />
        <path
          d="m 81.9512,123.764 -9.2344,1.004 -8.6672,2.667 0,-3 4.2348,-4.67 13.3332,-6"
          fill="#ffffff"
          fillOpacity={1}
          fillRule="nonzero"
          stroke="none"
          id="path80"
        />
        <path
          d="m 67.0508,122.765 c 0,0 10.334,-4.334 13.6672,-3.334 l 0.3316,-3.996 -9.3316,1.996 -5.6672,4 1,1.334"
          fill="#dcd9d8"
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
          id="path82"
        />
        <path
          d="m 134.582,106.63 c -5.656,0.166 -10.766,0.838 -15.24,2.1 0.304,1.834 -0.265,3.634 0.192,4.955 1.247,0.898 3.337,0.884 5.222,1.095 -1.63,0.801 -3.92,1.118 -5.801,0.655 -0.044,1.273 -0.615,2.062 -0.961,3.058 3.18,1.135 10.687,8.576 14.91,6.112 2.012,-1.172 2.867,-7.866 3.023,-11.121 0.13,-2.7 -0.245,-5.424 -1.345,-6.854"
          fill="#d33833"
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
          id="path84"
        />
        <path
          d="m 134.582,106.63 c -5.656,0.166 -10.766,0.838 -15.24,2.1 0.304,1.834 -0.265,3.634 0.192,4.955 1.247,0.898 3.337,0.884 5.222,1.095 -1.63,0.801 -3.92,1.118 -5.801,0.655 -0.044,1.273 -0.615,2.062 -0.961,3.058 3.18,1.135 10.687,8.576 14.91,6.112 2.012,-1.172 2.867,-7.866 3.023,-11.121 0.13,-2.7 -0.245,-5.424 -1.345,-6.854 z"
          fill="none"
          stroke="#d33833"
          strokeWidth={2}
          strokeLinecap="butt"
          strokeLinejoin="miter"
          strokeMiterlimit={4}
          strokeOpacity={1}
          strokeDasharray={'none'}
          id="path86"
        />
        <path
          d="m 107.535,115.876 c -0.015,-0.428 -0.033,-0.859 -0.05,-1.291 -1.766,-1.16 -4.617,-1.146 -6.555,-2.121 2.857,-0.125 5.106,-0.813 7.052,-1.783 -0.043,-1.078 -0.084,-2.155 -0.126,-3.233 -3.237,-2.216 -6.194,-5.516 -10.0052,-7.5941 -1.802,-0.9828 -8.1262,-3.5117 -10.0434,-3.0648 -1.0847,0.2519 -1.1824,1.598 -1.616,2.8668 -0.9238,2.7171 -3.0508,7.0421 -3.2363,11.1321 -0.2363,5.166 -0.7578,13.824 4.8094,12.76 4.4914,-0.857 9.7152,-2.926 13.1925,-4.826 2.125,-1.162 3.354,-2.598 6.578,-2.846"
          fill="#d33833"
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
          id="path88"
        />
        <path
          d="m 107.535,115.876 c -0.015,-0.428 -0.033,-0.859 -0.05,-1.291 -1.766,-1.16 -4.617,-1.146 -6.555,-2.121 2.857,-0.125 5.106,-0.813 7.052,-1.783 -0.043,-1.078 -0.084,-2.155 -0.126,-3.233 -3.237,-2.216 -6.194,-5.516 -10.0052,-7.5941 -1.802,-0.9828 -8.1262,-3.5117 -10.0434,-3.0648 -1.0847,0.2519 -1.1824,1.598 -1.616,2.8668 -0.9238,2.7171 -3.0508,7.0421 -3.2363,11.1321 -0.2363,5.166 -0.7578,13.824 4.8094,12.76 4.4914,-0.857 9.7152,-2.926 13.1925,-4.826 2.125,-1.162 3.354,-2.598 6.578,-2.846 z"
          fill="none"
          stroke="#d33833"
          strokeWidth={2}
          strokeLinecap="butt"
          strokeLinejoin="miter"
          strokeMiterlimit={4}
          strokeOpacity={1}
          strokeDasharray={'none'}
          id="path90"
        />
        <path
          d="m 110.75,109.712 c -0.494,2.814 -1.065,3.617 -0.844,6.072 7.505,5.004 8.914,-8.595 0.844,-6.072"
          fill="#d33833"
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
          id="path92"
        />
        <path
          d="m 110.75,109.712 c -0.494,2.814 -1.065,3.617 -0.844,6.072 7.505,5.004 8.914,-8.595 0.844,-6.072 z"
          fill="none"
          stroke="#d33833"
          strokeWidth={2}
          strokeLinecap="butt"
          strokeLinejoin="miter"
          strokeMiterlimit={4}
          strokeOpacity={1}
          strokeDasharray={'none'}
          id="path94"
        />
        <path
          d="m 121.617,107.431 c 0,0 -2.334,3.334 -0.667,4.334 1.667,1 3.334,-0.001 4.334,1.666 1,1.667 0,2.667 0.333,4.667 0.333,2 2.001,2.334 3.667,2.667 1.666,0.333 6.334,1 7,-0.667 l -2,6 -4,1.333 -12.667,-7.333 -0.667,-3.667 0,-7.333"
          fill="#ef3d3a"
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
          id="path96"
        />
        <path
          d="m 86.6172,96.4309 c -0.4004,5.2021 -0.8242,10.3971 -1.2957,15.5941 -0.7055,7.76 1.864,6.406 8.5906,6.406 1.0274,0 6.3259,-1.225 6.7049,-2 1.818,-3.713 -3.04,-2.888 2.094,-5.688 4.334,-2.363 11.99,1.435 10.239,6.688 -0.98,1.168 -5.106,0.364 -6.585,1.131 -2.604,1.35 -5.208,2.7 -7.8123,4.05 -3.3132,1.719 -10.9707,4.225 -14.5031,1.823 -8.9504,-6.087 0.5649,-21.296 3.7578,-27.6459"
          fill="#ef3d3a"
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
          id="path98"
        />
        <path
          d="m 95.3887,214.532 c -9.0852,2.116 -13.5996,-3.802 -16.3535,-9.94 -2.459,0.596 -1.4805,3.94 -0.8594,5.644 1.6262,4.472 8.1797,10.425 13.5344,9.618 2.3043,-0.347 5.4226,-2.454 3.6785,-5.322"
          fill="#231f20"
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
          id="path100"
        />
        <path
          d="m 139.655,204.186 c 0.143,-0.006 0.288,-0.011 0.431,-0.017 2.053,-4.265 3.83,-8.783 6.42,-12.548 -1.735,-4.041 -13.138,-7.617 -12.962,-0.361 2.466,1.078 6.723,0.22 8.909,1.597 -1.264,3.469 -3.088,6.422 -2.798,11.329"
          fill="#231f20"
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
          id="path102"
        />
        <path
          d="m 100.04,204.075 c 1.948,-3.571 2.582,-7.323 5.351,-10.022 1.247,-1.215 3.672,-2.696 2.47,-6.075 -0.281,-0.797 -2.334,-2.574 -3.519,-2.923 -4.329,-1.278 -14.4162,-0.264 -11.0002,5.133 3.5801,-0.167 8.3922,-2.325 11.0682,0.274 -2.055,3.285 -5.7186,9.784 -4.37,13.613"
          fill="#231f20"
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
          id="path104"
        />
        <path
          d="m 138.03,167.781 c -6.518,-4.187 -13.786,-8.74 -24.466,-7.684 -2.282,1.984 -3.152,6.399 -0.935,9.315 1.154,-1.984 0.429,-5.633 3.645,-6.182 6.06,-1.037 13.113,3.707 17.472,5.365 2.703,4.557 -0.233,6.233 -2.668,9.166 -4.985,6.009 -11.672,13.457 -11.429,22.453 2.015,1.461 2.189,-2.23 2.478,-2.902 2.603,-6.092 9.154,-13.883 13.935,-19.097 1.174,-1.284 3.107,-2.516 3.322,-3.365 0.62,-2.469 -1.613,-5.427 -1.354,-7.069"
          fill="#231f20"
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
          id="path106"
        />
        <path
          d="m 52.1016,172.189 c -2.043,1.166 -2.5293,6.302 -4.9278,6.448 -3.4277,0.208 -2.8027,-6.663 -2.789,-10.681 -2.3594,2.142 -2.7743,8.737 -1.041,12.124 -1.9754,0.97 -2.8575,-1.07 -3.9532,-1.789 1.4082,10.23 14.9649,4.745 12.711,-6.102"
          fill="#231f20"
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
          id="path108"
        />
        <path
          d="m 142.18,163.521 c -3.034,-5.775 -7.326,-12.135 -16.229,-12.32 -0.181,1.865 -0.32,4.703 0.01,5.826 6.806,0.654 11.008,4.118 16.219,6.494"
          fill="#231f20"
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
          id="path110"
        />
        <path
          d="m 99.5266,159.777 c 5.6784,-2.986 16.1144,-3.307 23.8324,-3.081 0.414,-1.691 0.404,-3.78 0.42,-5.842 -9.921,-0.495 -21.651,1.96 -24.2524,8.923"
          fill="#231f20"
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
          id="path112"
        />
        <path
          d="m 98.4473,154.209 c 3.9267,-9.859 17.4227,-8.724 28.8037,-8.452 -0.501,-1.28 -1.587,-2.792 -2.937,-3.339 -3.647,-1.484 -13.706,-2.61 -18.769,0.079 -3.211,1.707 -5.274,5.564 -7.0333,7.825 -0.8496,1.092 -5.0801,3.881 -0.0644,3.887"
          fill="#231f20"
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
          id="path114"
        />
        <path
          d="m 137.556,99.8262 c -4.608,-7.8922 -9.017,-15.9981 -14.484,-22.9594 2.292,6.7391 3.273,18.0184 3.619,26.6172 4.795,2.244 8.901,-0.505 10.865,-3.6578"
          fill="#81b0c4"
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
          id="path116"
        />
        <path
          d="m 162.352,71.4609 c -5.159,-1.0328 -8.784,-6.0468 -13.817,-5.725 2.766,3.8993 7.613,5.543 13.817,5.725"
          fill="#231f20"
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
          id="path118"
        />
        <path
          d="m 164.628,63.3871 c -4.205,-0.4441 -9.144,-1.125 -13.409,-0.7742 2.019,3.084 9.798,2.0199 13.409,0.7742"
          fill="#231f20"
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
          id="path120"
        />
        <path
          d="m 166.085,56.4262 c -4.726,-0.1024 -10.6,-0.0082 -15.092,0.3687 2.657,2.8539 12.027,1.059 15.092,-0.3687"
          fill="#231f20"
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
          id="path122"
        />
        <path
          d="m 128.664,37.377 c 0.678,-5.9352 3.031,-11.9489 2.736,-18.4489 -2.613,-0.8812 -4.114,-1.6519 -7.615,-1.6472 -0.247,5.5242 -0.986,13.9691 -0.765,19.2351 1.722,-0.114 4.261,1.2301 5.644,0.861"
          fill="#dcd9d8"
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
          id="path124"
        />
        <path
          d="m 121.045,124.849 c -2.373,-1.549 -4.394,-3.483 -6.673,-5.137 -5.054,-0.25 -7.812,0.35 -11.525,3.252 0.061,0.233 0.434,0.129 0.448,0.415 5.41,-2.411 12.287,0.982 17.75,1.47"
          fill="#f0d6b7"
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
          id="path126"
        />
        <path
          d="m 92.6445,87.9711 c 1.4864,6.441 7.3106,9.7769 12.5995,13.3239 5.459,-6.9282 8.779,-15.838 12.435,-24.436 -8.638,2.6039 -17.464,6.8289 -25.0345,11.1121"
          fill="#81b0c4"
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
          id="path128"
        />
        <path
          d="m 123.02,36.516 c -0.221,-5.266 0.518,-13.7109 0.765,-19.2351 3.501,-0.0047 5.002,0.766 7.615,1.6472 0.295,6.5 -2.058,12.5137 -2.736,18.4489 -1.383,0.3691 -3.922,-0.975 -5.644,-0.861 z M 68.5059,66.4648 C 70.8145,45.2418 74.1582,27.4012 80.291,8.60781 93.9023,4.475 110.311,4.11484 122.342,7.84414 120.133,18.4512 121.098,31.3648 119.807,42.684 c -0.973,8.5078 -0.477,17.068 -1.811,25.748 -14.578,3.0328 -35.1835,0.709 -49.4901,-1.9672 z m 52.9371,1.834 c -0.123,-9.1148 0.408,-18.1058 1.104,-27.232 3.5,0.5254 5.875,0.8762 9.127,1.5891 -1.056,8.7859 -0.926,18.6722 -3.077,26.4441 -2.486,-0.0238 -4.675,0.0289 -7.154,-0.8012 z m 17.755,1.4692 c -1.661,0.3808 -3.595,0.0148 -5.182,-0.016 0.746,-7.4301 2.556,-15.629 3.193,-23.4282 2.497,-0.0777 3.831,1.1 5.885,1.4961 0.11,6.8461 -0.598,16.2781 -3.896,21.9481 z m 26.884,-24.5629 c 5.205,1.264 8.478,7.639 7.022,14.1859 -0.977,4.4 -2.717,12.6852 -4.579,15.5 -1.376,2.082 -5.107,4.8078 -8.086,2.9 -4.846,-3.1031 -13.383,-4.0039 -16.917,-7.7601 1.772,-5.9 2.322,-14.0039 3.053,-21.4797 6.054,-0.3774 13.503,1.666 18.538,-0.5024 -3.515,-1.1386 -8.076,-1.1476 -11.113,-2.807 2.482,-1.1988 8.293,-0.9566 12.082,-0.0367 z M 117.679,76.859 c -3.656,8.598 -6.976,17.5078 -12.435,24.436 C 99.9551,97.748 94.1309,94.4121 92.6445,87.9711 100.215,83.6879 109.041,79.4629 117.679,76.859 z m 9.012,26.625 c -0.346,-8.5988 -1.327,-19.8781 -3.619,-26.6172 5.467,6.9613 9.876,15.0672 14.484,22.9594 -1.964,3.1528 -6.07,5.9018 -10.865,3.6578 z m -10.216,3.63 c -2.071,0.223 -3.829,-2.381 -6.522,-1.255 -0.617,-0.682 -1.178,-1.421 -1.807,-2.087 5.948,-7.1681 8.651,-17.338 13.245,-25.7618 2.465,8.0918 2.181,16.957 2.724,25.7888 -3.387,-0.215 -5.266,3.063 -7.64,3.315 z m -6.569,8.67 c -0.221,-2.455 0.35,-3.258 0.844,-6.072 8.07,-2.523 6.661,11.076 -0.844,6.072 z m -8.949,2.938 c -3.4773,1.9 -8.7011,3.969 -13.1925,4.826 -5.5672,1.065 -5.0457,-7.594 -4.8094,-12.76 0.1855,-4.09 2.3125,-8.415 3.2363,-11.1321 0.4336,-1.2688 0.5313,-2.6149 1.616,-2.8668 1.9172,-0.4469 8.2414,2.082 10.0434,3.0648 3.8112,2.0781 6.7682,5.3781 10.0052,7.5941 0.042,1.078 0.083,2.155 0.126,3.233 -1.946,0.97 -4.195,1.658 -7.052,1.783 1.938,0.975 4.789,0.961 6.555,2.121 0.017,0.432 0.035,0.863 0.05,1.291 -3.224,0.248 -4.453,1.684 -6.578,2.846 z m -33.2136,6.033 c -2.886,-2.93 8.0945,-6.924 11.5906,-7.139 -0.0195,1.854 1.0566,3.602 0.8398,4.932 -4.1523,0.729 -9.6093,0.248 -12.4304,2.207 z m 35.5516,-1.376 c -0.014,-0.286 -0.387,-0.182 -0.448,-0.415 3.713,-2.902 6.471,-3.502 11.525,-3.252 2.279,1.654 4.3,3.588 6.673,5.137 -5.463,-0.488 -12.34,-3.881 -17.75,-1.47 z m 32.632,-9.895 c -0.156,3.255 -1.011,9.949 -3.023,11.121 -4.223,2.465 -11.73,-4.977 -14.91,-6.112 0.346,-0.996 0.917,-1.785 0.961,-3.058 1.881,0.463 4.171,0.146 5.801,-0.655 -1.885,-0.211 -3.975,-0.197 -5.222,-1.095 -0.457,-1.321 0.112,-3.121 -0.192,-4.955 4.474,-1.262 9.584,-1.934 15.24,-2.1 1.1,1.43 1.475,4.154 1.345,6.854 z m -73.0422,8.437 c -0.9063,0.646 -7.0371,8.623 -7.877,8.292 C 43.9141,125.838 33.541,118.273 24.2715,111.118 33.1094,92.1539 36.677,68.9199 37.3074,46.5262 47.4316,41.791 56.3242,34.9648 70.0625,34.252 68.4727,45.5 67.0215,55.5352 66.1191,66.125 c -3.4519,1.4551 -8.4043,-0.066 -11.6347,0.4512 -0.0274,3.8929 4.9336,1.7047 5.3468,4.3226 0.3114,1.9801 -2.7296,2.1301 -1.7394,5.2481 2.5254,-0.918 3.8516,-2.9457 6.5449,-3.7071 2.461,5.384 -0.0344,14.9102 0.3203,19.4102 0.0672,0.8449 0.4219,4.6809 2.3145,4.0078 1.675,-0.5957 -0.0957,-10.2019 0.0879,-14.4609 0.1672,-3.9239 -0.4739,-7.7207 1.1152,-10.184 13.2754,1.807 26.7656,2.975 41.1294,3.3691 -3.16,1.3559 -6.914,2.6391 -11.0298,4.959 -2.2312,1.2578 -9.2644,3.875 -9.9082,5.9942 -1.0273,3.3769 2.6953,5.1757 3.332,8.0707 -6.7011,-3.6547 -8.0085,3.5031 -9.5937,8.5741 -1.4363,4.593 -2.2539,8.024 -2.6063,10.673 -5.7726,2.752 -11.9445,5.539 -16.9132,9.068 z m 67.1792,7.327 c 9.243,4.482 10.909,-16.751 7.286,-23.591 0.56,-2.04 2.486,-2.821 3.272,-4.655 -5.158,-9.2399 -10.887,-17.8649 -16.15,-26.9961 3.915,2.4371 9.507,0.4359 14.114,2.2601 1.684,0.666 2.903,4.5211 4.178,7.6051 3.507,8.4848 7.189,19.1819 8.827,27.2789 0.37,1.845 1.378,5.865 1.152,7.507 -0.403,2.94 -4.392,5.12 -6.421,6.938 -3.738,3.358 -6.092,6.313 -9.991,9.453 -1.581,-2.334 -4.974,-3.902 -6.267,-5.8 z m -88.3179,81.968 c -4.4043,-4.846 -3.4824,-13.926 -2.9492,-20.386 7.9609,5.008 18.5273,-0.396 18.4277,-8.914 3.8008,0.101 1.4199,4.747 0.7324,7.74 -2.2468,9.776 3.7852,20.397 0.2735,29.337 -6.8184,-0.517 -12.42,-3.302 -16.4844,-7.777 z m 31.5137,28.126 c -9.9707,-2.826 -22.7493,-10.071 -26.8465,-19.028 3.1726,0.461 5.375,2.061 8.5047,2.259 1.1828,0.077 2.7324,-0.496 4.0918,-0.158 2.709,0.672 4.9953,6.746 7.039,9.006 1.9922,2.207 4.3867,3.15 6.0254,5.162 1.0528,0.508 2.6094,0.473 2.6692,2.054 -0.4563,0.488 -0.9368,0.86 -1.4836,0.705 z m 51.9032,-2.658 c -10.349,5.839 -27.8661,10.231 -38.8747,4.743 -8.8828,-4.429 -20.8899,-11.757 -24.9836,-21.043 3.8242,-8.961 -1.1328,-17.172 -1.4492,-26.27 -0.168,-4.841 2.2793,-9.067 2.4668,-14.337 -1.3086,-2.159 -5.3067,-2.425 -8.0743,-2.277 -0.9316,4.662 -2.5625,9.902 -7.3632,10.428 -6.793,0.743 -11.7598,-4.879 -12.0684,-10.754 -0.3652,-6.909 5.3066,-18.36 13.3457,-17.565 3.1055,0.307 3.8684,3.42 7.252,3.388 1.8339,-3.659 -2.8289,-4.808 -3.3086,-7.425 -0.125,-0.676 0.3867,-3.318 0.6843,-4.557 1.4602,-6.033 4.7153,-13.841 7.9192,-18.434 4.0664,-5.826 12.0555,-6.704 20.6504,-7.275 1.5351,3.307 7.1902,3.035 10.875,2.17 -4.416,1.749 -8.5215,5.989 -11.9239,9.742 -3.9082,4.306 -7.8671,8.925 -8.0671,14.553 7.3855,-10.246 13.4871,-19.194 26.9168,-23.701 10.1618,-3.408 22.0298,1.562 29.8378,7.045 3.24,2.279 5.174,5.895 7.477,9.205 8.617,12.395 12.638,30.087 11.754,47.235 -0.364,7.072 -0.348,14.12 -2.721,18.878 -2.48,4.975 -10.868,9.426 -15.778,4.926 -0.91,4.838 4.083,7.83 9.948,6.089 -4.182,5.397 -8.571,11.882 -14.515,15.236 z M 144.444,77.1168 c 8.087,4.0203 23.197,10.8211 28.267,-0.0148 1.871,-3.9942 4.066,-10.7461 5.035,-14.8692 1.369,-5.8168 -1.484,-18.043 -7.463,-19.9949 -5.281,-1.7238 -11.443,-1.6188 -17.804,-0.341 -0.749,0.623 -1.583,1.709 -2.166,2.841 -4.542,0.1762 -8.795,-0.2438 -12.383,-2.1109 0.34,-3.359 -1.932,-3.8981 -4.062,-4.5899 -1.579,-6.2609 3.159,-14.4371 2.025,-20.1461 -0.809,-4.0672 -5.813,-4.6961 -9.491,-5.457 -0.12,-2.2602 0.161,-4.14689 0.412,-6.059 -0.841,-3.09883 -4.613,-4.86289 -8.187,-5.29492 -11.759,-1.414064 -29.6133,-2.049221 -40.9239,2.01797 -3.1562,7.74175 -5.6426,17.15785 -8.2715,25.99805 -11.0312,-1.1781 -19.9531,4.7598 -28.364,8.65 -2.9121,1.35 -6.9406,2.0937 -8.0285,4.4117 -1.0547,2.2442 -0.6231,6.5453 -0.8848,10.6082 -0.666,10.377 -1.2363,20.386 -3.9766,31.011 -1.2304,4.7679 -3.375,8.975 -4.8711,13.5691 -1.3828,4.2579 -3.7988,9.5199 -4.4289,13.7659 -0.9343,6.293 4.9914,6.643 8.7805,9.37 5.8574,4.217 10.4551,6.549 16.7988,10.355 1.8789,1.127 7.545,3.98 8.1895,5.294 1.2812,2.605 -2.1992,6.278 -3.1297,8.32 -1.4719,3.229 -2.2395,5.972 -2.4504,9.158 -5.3215,0.841 -9.3555,4.008 -11.7922,7.579 -4.0308,5.91 -6.8262,16.844 -3.3387,25.161 0.2735,0.655 1.6375,1.943 1.8387,2.949 0.3969,1.981 -0.7469,4.615 -0.818,6.722 -0.3664,10.81 1.829,20.124 9.1063,23.384 2.9543,11.769 13.5281,15.682 23.4902,21.531 3.7239,2.186 7.8289,3.583 12.0684,5.143 15.2082,5.597 38.5419,4.543 51.1639,-5.003 5.352,-4.048 13.907,-12.595 16.967,-18.783 8.082,-16.337 7.508,-43.64 1.855,-63.513 -0.76,-2.668 -1.862,-6.59 -3.401,-9.795 -1.073,-2.238 -4.408,-6.716 -4.003,-8.692 0.417,-2.043 7.604,-7.5 9.145,-8.986 2.775,-2.677 8.047,-6.23 8.474,-9.608 0.459,-3.595 -1.584,-8.513 -2.619,-11.982 -3.46,-11.5769 -6.836,-22.2781 -10.759,-32.5992"
          fill="#231f20"
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
          id="path130"
        />
        <path
          d="m 90.491,157.255 c 0.4387,0.584 2.8508,1.471 6.2258,-0.154 0,0 -4,-0.667 -3.6672,-7.336 l -1.6668,0.334 c 0,0 -1.7226,6.047 -0.8918,7.156"
          fill="#f7e4cd"
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
          id="path132"
        />
        <path
          d="m 119.717,99.934 c 0,-1.0121 -0.821,-1.8328 -1.834,-1.8328 -1.012,0 -1.833,0.8207 -1.833,1.8328 0,1.012 0.821,1.834 1.833,1.834 1.013,0 1.834,-0.822 1.834,-1.834"
          fill="#1d1919"
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
          id="path134"
        />
        <path
          d="m 121.55,91.434 c 0,-1.0121 -0.821,-1.8328 -1.834,-1.8328 -1.012,0 -1.833,0.8207 -1.833,1.8328 0,1.0121 0.821,1.834 1.833,1.834 1.013,0 1.834,-0.8219 1.834,-1.834"
          fill="#1d1919"
          fillOpacity={1}
          fillRule="evenodd"
          stroke="none"
          id="path136"
        />
      </g>
    </g>
  </SvgIcon>
);

export const JiraIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 32 32" fill="none">
    <path
      d="M27.0055 4H15.4512C15.4512 6.88 17.7826 9.21143 20.6626 9.21143H22.7883V11.2686C22.7883 14.1486 25.1197 16.48 27.9997 16.48V4.99429C27.9997 4.44571 27.554 4 27.0055 4Z"
      fill="#2684FF"
    />
    <path
      d="M21.2799 9.76001H9.72559C9.72559 12.64 12.057 14.9714 14.937 14.9714H17.0627V17.0286C17.0627 19.9086 19.3942 22.24 22.2742 22.24V10.7543C22.2742 10.2057 21.8284 9.76001 21.2799 9.76001Z"
      fill="url(#paint0_linear)"
    />
    <path
      d="M15.5543 15.52H4C4 18.4 6.33143 20.7314 9.21143 20.7314H11.3371V22.7886C11.3371 25.6686 13.6686 28 16.5486 28V16.5143C16.5486 15.9657 16.1029 15.52 15.5543 15.52Z"
      fill="url(#paint1_linear)"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="22.0343"
        y1="9.77256"
        x2="17.1181"
        y2="14.8424"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.176" stop-color="#0052CC" />
        <stop offset="1" stop-color="#2684FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="16.6411"
        y1="15.5637"
        x2="10.9568"
        y2="21.0943"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.176" stop-color="#0052CC" />
        <stop offset="1" stop-color="#2684FF" />
      </linearGradient>
    </defs>
  </SvgIcon>
);

export const ConfluenceIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 32 32" fill="none">
    <path
      d="M4.87273 21.5569C4.61902 21.9559 4.32905 22.4274 4.11158 22.7901C3.89411 23.1528 4.00285 23.6243 4.3653 23.8419L9.33088 26.8884C9.69333 27.106 10.1645 26.9972 10.382 26.6345C10.5632 26.3081 10.8169 25.8729 11.1069 25.4014C13.0641 22.1735 15.0576 22.5362 18.6096 24.2408L23.539 26.562C23.9377 26.7434 24.3726 26.562 24.5538 26.1993L26.9098 20.8678C27.091 20.5052 26.9098 20.0337 26.5473 19.8523C25.4962 19.3808 23.4302 18.4016 21.618 17.4949C14.9126 14.267 9.22215 14.4846 4.87273 21.5569Z"
      fill="url(#paint0_linear)"
    />
    <path
      d="M27.1274 9.44314C27.3812 9.04419 27.6711 8.57269 27.8886 8.21001C28.1061 7.84732 27.9973 7.37583 27.6349 7.15822L22.6693 4.11165C22.3068 3.89404 21.8356 4.00285 21.6182 4.36553C21.437 4.69195 21.1832 5.12718 20.8933 5.59867C18.936 8.82657 16.9426 8.46389 13.3905 6.75926L8.46118 4.43807C8.06248 4.25673 7.62754 4.43807 7.44632 4.80076L5.09038 10.1322C4.90916 10.4949 5.09038 10.9664 5.45283 11.1478C6.50394 11.6193 8.56992 12.5985 10.3822 13.5052C17.0875 16.6969 22.778 16.5155 27.1274 9.44314Z"
      fill="url(#paint1_linear)"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="26.7906"
        y1="28.4674"
        x2="11.7924"
        y2="19.8546"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0052CC" />
        <stop offset="0.9182" stop-color="#2380FB" />
        <stop offset="1" stop-color="#2684FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear"
        x1="5.20945"
        y1="2.52323"
        x2="20.2079"
        y2="11.1361"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#0052CC" />
        <stop offset="0.9182" stop-color="#2380FB" />
        <stop offset="1" stop-color="#2684FF" />
      </linearGradient>
    </defs>
  </SvgIcon>
);

export const GrafanaIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24" fill="none">
    <path
      d="M20.3595 9.74907C20.3204 9.3967 20.2812 8.96601 20.1246 8.49618 20.0071 8.02634 19.8114 7.51736 19.5373 6.96922 19.2632 6.42108 18.9109 5.87293 18.4802 5.32479 18.3236 5.12903 18.1278 4.89411 17.8929 4.69835 18.2061 3.44546 17.5014 2.38833 17.5014 2.38833 16.3268 2.31002 15.5437 2.7407 15.2696 2.97562 15.2305 2.97562 15.1913 2.93647 15.113 2.89731 14.9173 2.81901 14.7215 2.7407 14.4866 2.6624 14.2517 2.58409 14.0559 2.54494 13.821 2.46663 13.5861 2.42748 13.3511 2.38833 13.1554 2.34917 13.1162 2.34917 13.0771 2.34917 13.0379 2.34917 12.5289.704752 11.0411.0 11.0411.0 9.3967 1.05713 9.08348 2.50579 9.08348 2.50579s0 .0391499999999998.0.0783C9.00517 2.62324 8.88771 2.62324 8.8094 2.6624 8.69194 2.70155 8.57448 2.7407 8.41787 2.77986 8.30041 2.81901 8.18296 2.85816 8.02634 2.93647 7.79143 3.05393 7.51736 3.17138 7.28244 3.28884 7.04752 3.4063 6.81261 3.56291 6.57769 3.71953 6.53854 3.71953 6.53854 3.68037 6.53854 3.68037c-2.31002-.86136-4.34598.19577-4.34598.19577C1.9968 6.30362 3.09308 7.86973 3.328 8.1438 3.28884 8.30041 3.21054 8.45703 3.17139 8.61364c-.15661.54814-.31323 1.13543-.39153 1.72276C2.77986 10.4147 2.7407 10.493 2.7407 10.5713.626446 11.6284.0 13.7818.0 13.7818c1.76188 2.036 3.83699 2.1534 3.83699 2.1534C4.11106 16.4051 4.38513 16.8357 4.7375 17.2664 4.89411 17.423 5.05073 17.6188 5.16819 17.7754 4.54174 19.6156 5.24649 21.1426 5.24649 21.1426 7.20413 21.2209 8.49618 20.2812 8.77025 20.0463 8.96601 20.1246 9.16178 20.1637 9.35754 20.2421 9.94483 20.3987 10.5713 20.477 11.1977 20.5161c.156600000000001.0.3133.0.469900000000001.0H11.7459 11.785 11.8633 11.9416c.9397 1.3312 2.545 1.527 2.545 1.527 1.1746-1.2138 1.2137-2.4275 1.2137-2.7016V19.3024 19.2632C15.9352 19.1066 16.1701 18.9109 16.4051 18.7151 16.8749 18.2844 17.2664 17.8146 17.6188 17.3056 17.658 17.2664 17.6971 17.2273 17.6971 17.149 19.0283 17.2273 19.9288 16.3268 19.9288 16.3268c-.2349-1.3704-1.018-2.036-1.1746-2.1534H18.7151C18.7151 14.095 18.7151 14.0167 18.7151 13.9384c0-.156599999999999.0-.3132.0-.4306V13.312 13.2728 13.2337 13.1945 13.1162v-.1174C18.7151 12.9596 18.7151 12.9205 18.7151 12.8813 18.7151 12.8422 18.7151 12.803 18.7151 12.7638v-.1174-.1175C18.6759 12.3723 18.6759 12.2157 18.6368 12.0982 18.4802 11.511 18.2844 10.9628 17.9712 10.4538 17.658 9.94484 17.3056 9.51415 16.8749 9.12263 16.4442 8.7311 15.9744 8.45703 15.4654 8.22211 14.9564 7.98719 14.4474 7.86973 13.8993 7.79143 13.6252 7.75227 13.3903 7.75227 13.1162 7.75227H13.0379 12.9988 12.9596 12.9205 12.8422C12.803 7.75227 12.7638 7.75227 12.7247 7.75227 12.6072 7.75227 12.4506 7.79143 12.3332 7.79143 11.8242 7.86973 11.3152 8.0655 10.8845 8.33957 10.4538 8.61364 10.0623 8.92686 9.74907 9.27924 9.43585 9.63161 9.20093 10.0623 9.04432 10.493 8.88771 10.9237 8.8094 11.3543 8.77025 11.785c0 .1175.0.1958.0.3132C8.77025 12.1374 8.77025 12.1374 8.77025 12.1766V12.2549c0 .0391000000000012.0.1174.0.156600000000001C8.8094 12.6072 8.84856 12.8422 8.88771 13.0379 9.00517 13.4294 9.20093 13.7818 9.3967 14.095 9.63161 14.4083 9.90568 14.6432 10.1798 14.8389 10.4538 15.0347 10.7671 15.1913 11.0803 15.2696 11.3935 15.3479 11.6676 15.3871 11.9808 15.3871c.0390999999999995.0.0783000000000005.0.1174.0H12.1374 12.1766C12.2157 15.3871 12.2549 15.3871 12.2549 15.3871s0 0 .0391000000000012.0H12.3332 12.3723C12.4115 15.3871 12.4506 15.3871 12.4898 15.3871 12.5289 15.3871 12.5681 15.3871 12.6072 15.3479 12.6855 15.3479 12.7247 15.3088 12.803 15.3088 12.9205 15.2696 13.0379 15.2305 13.1554 15.1522c.1174-.039200000000001.1957-.1175.3132-.1958C13.5077 14.9564 13.5078 14.9173 13.5469 14.8781 13.6644 14.7998 13.6644 14.6432 13.5861 14.5649S13.3903 14.4474 13.312 14.5257C13.2728 14.5257 13.2728 14.5649 13.2337 14.5649 13.1554 14.604 13.0771 14.6432 12.9596 14.6823 12.8813 14.7215 12.7638 14.7215 12.6855 14.7606 12.6464 14.7606 12.5681 14.7606 12.5289 14.7606 12.4898 14.7606 12.4898 14.7606 12.4506 14.7606 12.4115 14.7606 12.4115 14.7606 12.3723 14.7606 12.3332 14.7606 12.3332 14.7606 12.294 14.7606 12.2549 14.7606 12.2157 14.7606 12.2157 14.7606H12.1766 12.1374C12.0982 14.7606 12.0983 14.7606 12.0591 14.7606 11.8242 14.7215 11.6284 14.6823 11.3935 14.5649 11.1586 14.4866 10.9628 14.33 10.767 14.1734 10.5713 14.0167 10.4147 13.7818 10.2972 13.5861 10.1798 13.3903 10.0623 13.1162 10.0231 12.8422 9.98399 12.7247 9.98399 12.5681 9.98399 12.4506 9.98399 12.4115 9.98399 12.3723 9.98399 12.3332V12.294 12.2549C9.98399 12.1766 9.98399 12.0982 10.0231 12.0199c.1175-.587299999999999.3916-1.1354.8614-1.6052C11.002 10.2972 11.1194 10.2189 11.2369 10.1014 11.3543 10.0231 11.511 9.94484 11.6284 9.86653 11.785 9.78823 11.9416 9.74907 12.0591 9.70992 12.2157 9.67077 12.3723 9.63161 12.5289 9.63161c.0783000000000005.0.156599999999999.0.2349.0H12.803 12.8813 12.9205 12.9988C13.1554 9.63161 13.3511 9.67077 13.5077 9.70992 13.8601 9.78822 14.1733 9.90568 14.4866 10.1014 15.113 10.4538 15.622 11.002 15.9744 11.6284 16.131 11.9416 16.2485 12.294 16.3268 12.6464 16.3268 12.7247 16.3659 12.8422 16.3659 12.9205V12.9988 13.0771C16.3659 13.1162 16.3659 13.1162 16.3659 13.1554 16.3659 13.1945 16.3659 13.1945 16.3659 13.2337V13.312 13.3903c0 .0390999999999995.0.1174.0.156600000000001C16.3659 13.6644 16.3659 13.7427 16.3268 13.8601 16.3268 13.9384 16.2876 14.0559 16.2876 14.1342S16.2484 14.33 16.2093 14.4083C16.1701 14.604 16.0918 14.7998 16.0135 14.9564 15.8569 15.3088 15.6612 15.6612 15.4262 16.0135 14.9564 16.64 14.33 17.1881 13.5861 17.5013 13.2337 17.658 12.8422 17.7754 12.4506 17.8537 12.2549 17.8929 12.0591 17.8929 11.8633 17.932H11.8242 11.785 11.7067 11.6284 11.5893c.0390999999999995.0.0.0.0.0-.1175.0-.1958.0-.3133.0C10.8454 17.8929 10.4147 17.8146 10.0231 17.6971 9.63161 17.5797 9.20093 17.423 8.84856 17.2273 8.10465 16.8357 7.43905 16.2876 6.89091 15.622c-.27407-.3132-.50899-.6656-.6656-1.0571C6.02954 14.1734 5.87294 13.7818 5.75548 13.3903 5.63802 12.9988 5.55972 12.5681 5.55972 12.1766V12.0982 12.0591 11.9808v-.2349V11.7067 11.6284 11.5893c0-.0391999999999992.0-.1175.0-.156699999999999C5.55972 11.2369 5.59887 11.002 5.59887 10.8062 5.63802 10.6104 5.67717 10.3755 5.71633 10.1798 5.75548 9.98399 5.79463 9.74907 5.87293 9.55331 5.99039 9.16178 6.14701 8.77025 6.30362 8.37872 6.65599 7.63482 7.08667 6.96922 7.63481 6.46023 7.75227 6.34277 7.90889 6.18616 8.0655 6.0687 8.22211 5.95124 8.37873 5.83378 8.53534 5.75548 8.69195 5.63802 8.84855 5.55971 9.00517 5.48141 9.08347 5.44225 9.16178 5.4031 9.24009 5.36395 9.27924 5.36395 9.31839 5.32479 9.35754 5.32479S9.43585 5.28564 9.47501 5.28564C9.63162 5.20734 9.82738 5.16818 9.98399 5.08988 10.0231 5.08988 10.0623 5.05072 10.1015 5.05072 10.1406 5.05072 10.1798 5.01157 10.2189 5.01157 10.2972 4.97242 10.4147 4.97242 10.493 4.93327 10.5321 4.93327 10.5713 4.89411 10.6496 4.89411 10.6887 4.89411 10.7279 4.89411 10.8062 4.85496 10.8454 4.85496 10.8845 4.85496 10.9628 4.81581H11.0411 11.1194C11.1586 4.81581 11.1977 4.81581 11.276 4.77665 11.3152 4.77665 11.3935 4.77665 11.4327 4.7375 11.4718 4.7375 11.5501 4.7375 11.5893 4.7375 11.6284 4.7375 11.6676 4.7375 11.7067 4.7375H11.785 11.8242 11.8633C11.9025 4.7375 11.9808 4.7375 12.0199 4.7375H12.0982s.0391999999999992.0.0.0H12.1374C12.1766 4.7375 12.2157 4.7375 12.2549 4.7375 12.4506 4.7375 12.6072 4.7375 12.803 4.7375 13.1554 4.7375 13.5077 4.77665 13.8601 4.85496 14.5257 4.97242 15.1522 5.20734 15.7395 5.48141s1.0962.62644 1.5269 1.01797C17.3056 6.53853 17.3056 6.53853 17.3447 6.57769 17.3839 6.61684 17.3839 6.61684 17.423 6.65599 17.4622 6.69515 17.5405 6.7343 17.5796 6.8126 17.6188 6.89091 17.6971 6.89091 17.7363 6.96922 17.7754 7.04752 17.8537 7.08668 17.8929 7.12583 18.0886 7.32159 18.2452 7.51736 18.4019 7.75227 18.7151 8.1438 18.9892 8.57448 19.1849 8.96601 19.1849 9.00517 19.2241 9.00517 19.2241 9.04432 19.2241 9.08347 19.2632 9.08347 19.2632 9.12263 19.3024 9.16178 19.3024 9.20093 19.3415 9.27924 19.3807 9.31839 19.3807 9.35754 19.4198 9.43585 19.459 9.475 19.459 9.51415 19.4981 9.59246 19.5765 9.78823 19.6548 9.94484 19.6939 10.1014 19.7722 10.3755 19.8505 10.6104 19.8897 10.8062 19.9288 10.8845 20.0071 10.9628 20.0854 10.9237 20.1637 10.9237 20.2421 10.8454 20.2421 10.767 20.3987 10.2972 20.3987 10.0231 20.3595 9.74907z"
      fill="url(#paint0_linear_16731_2713)"
    ></path>
    <defs>
      <linearGradient
        id="paint0_linear_16731_2713"
        x1="10.2543"
        y1="28"
        x2="10.2543"
        y2="2.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#fff100"></stop>
        <stop offset="1" stop-color="#f05a28"></stop>
      </linearGradient>
    </defs>
  </SvgIcon>
);

export const SnykIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="-10 0 44 44">
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g id="Group-4">
        <g id="symbol">
          <path
            d="M19.4000196,2.73030042 L19.6530194,3.21114408 C20.0270321,3.91958668 23.3003118,10.1971552 23.3003118,12.4652208 L23.3001337,12.4652208 L23.3001337,12.5981895 L21.8161993,16.68476 C22.0574634,18.9123018 22.5373187,23.7523614 22.1750663,24.6979767 C21.9514426,25.2828579 21.099,26.4860887 20.3698623,27.4604687 L21.3571918,36.7644765 L19.9944241,37.7754002 L19.3774336,31.9519631 L19.194463,32.0876937 L19.1471306,31.6409488 C19.0534448,32.1073926 18.9325903,32.5763367 18.7759871,33.0124082 C18.463805,33.8825841 17.9121406,34.5420001 17.2065234,34.9325843 C17.1651842,37.0186547 15.2723127,38.1440943 13.4888474,38.1440943 C11.6905927,38.1440943 9.7818626,37.0195592 9.73981067,34.9342125 C9.03276799,34.5429047 8.4803909,33.8834886 8.16785238,33.0124082 C8.01605977,32.5890826 7.89743378,32.1354103 7.80453467,31.6828549 L7.75653748,32.1369245 L7.58004363,32.010497 L6.96473944,37.8314822 L5.60197171,36.8552932 L6.59179582,27.4886906 C5.8569561,26.5099688 4.98812039,25.2888279 4.76235853,24.697434 C4.40010607,23.7516378 4.86125185,18.9123018 5.10287228,16.6843981 L3.59203185,12.5983704 L3.59203185,12.4652208 C3.59203185,10.1971552 6.89150493,3.91958668 7.26605224,3.21114408 L7.34693601,3.06059743 C7.68010233,2.39296923 7.93615088,1.90651307 8.02104068,1.74594711 L8.95908072,0 C8.95908072,0 9.81578328,6.06777761 9.81515761,6.07317712 L10.2770606,9.35115549 L10.7077395,12.9714244 C11.2325572,12.8012101 11.9710496,12.603807 12.7633162,12.5233571 C12.9769732,11.9896018 13.208807,11.6341208 13.4636125,11.6341208 C13.9514487,11.6341208 14.4376628,12.1114304 14.8759498,12.62547 C15.3685533,12.7167057 15.8171345,12.8396577 16.1749031,12.952917 L16.6601751,9.3513143 L17.9761216,0 L18.8947657,1.74594711 C18.9648311,1.87866259 19.1508032,2.2340203 19.4000196,2.73030042 Z"
            id="Shape-Copy-45"
            fill="#FFFFFF"
          ></path>
          <path
            d="M26.9140127,34.231106 L13.4569111,43.9791375 L0,34.231106 L0,11.4997304 C0,11.4997304 4.97582791,9.6031746 13.4752004,9.6031746 C21.9745729,9.6031746 26.9140127,11.4997304 26.9140127,11.4997304 L26.9140127,34.231106 L26.9140127,34.231106 L26.9140127,34.231106 Z"
            id="Shape-Copy-44"
            fill="#FFFFFF"
          ></path>
          <polygon
            id="Shape-Copy-42"
            fill="#3B3B63"
            points="19.2470446 28.0995873 13.4465159 28.0995873 13.4465159 18.1676349 7.56085987 27.8092222 6.64578344 37.709746 13.3558854 42.6108571 13.4465159 42.6772063 20.3088153 37.6744762"
          ></polygon>
          <g id="Shape-+-Shape-Copy" transform="translate(0.859873, 10.650794)">
            <path
              d="M12.4872084,31.9245342 L0,22.8716571 L0,1.76130806 C0,1.76130806 4.61727059,0 12.5041797,0 C20.3910889,0 24.9745935,1.76130806 24.9745935,1.76130806 L24.9745935,22.8716571 L12.4872084,31.9245342 Z"
              id="Shape"
              fill="#DBDBDB"
            ></path>
            <path
              d="M12.6680961,0 C12.6622622,0 12.6567819,0.000178504922 12.650948,0.000178504922 L12.650948,31.9239987 L12.6511248,31.9239987 L25.1385099,22.8711216 L25.1385099,1.76130806 C25.1385099,1.76130806 20.5550053,0 12.6680961,0 L12.6680961,0 L12.6680961,0 Z"
              id="Shape"
              fill="#C6C6C6"
            ></path>
          </g>
          <polygon
            id="Shape-Copy-41"
            fill="#3B3B63"
            points="20.2745924 37.6540476 19.2148854 28.0995873 13.4140127 28.0995873 13.4140127 42.6550317"
          ></polygon>
          <polygon
            id="Shape-Copy-40"
            fill="#53537A"
            points="6.64578344 37.709746 13.4465159 42.6772063 13.4465159 18.1676349 7.56085987 27.8092222"
          ></polygon>
          <path
            d="M16.3733503,34.8874603 C16.3733503,36.5255873 14.8684013,37.3376667 13.4877898,37.3376667 C12.1071783,37.3376667 10.5717898,36.5255873 10.5717898,34.8874603"
            id="Shape-Copy-39"
            fill="#BC9375"
          ></path>
          <path
            d="M15.5272357,33.9590952 C15.5272357,35.880254 14.5098344,36.3953333 13.4724841,36.3953333 C12.4353057,36.3953333 11.4175605,35.880254 11.4175605,33.9590952"
            id="Shape-Copy-38"
            fill="#083251"
          ></path>
          <path
            d="M13.4724841,35.7346349 C12.3641083,35.7346349 11.8251401,34.9078889 11.8251401,33.2083016 L12.3536178,33.2083016 C12.3536178,35.1980794 13.1091019,35.1980794 13.4724841,35.1980794 C13.8356943,35.1980794 14.5913503,35.1980794 14.5913503,33.2083016 L15.1196561,33.2083016 C15.1196561,34.9078889 14.5806879,35.7346349 13.4724841,35.7346349 L13.4724841,35.7346349 Z"
            id="Shape-Copy-37"
            fill="#FFFFFF"
          ></path>
          <g id="Group-Copy-11" transform="translate(4.643312, 4.979986)">
            <path
              d="M17.6272166,8.64761698 C17.6272166,6.57507729 14.182051,0.0539979296 14.182051,0.0539979296 L13.0165796,8.32407729 L11.9706306,10.070109 L8.83570701,10.1996646 L8.82332484,10.2253313 L8.82332484,10.1996646 L5.68788535,10.070109 L4.64228025,8.32407729 L3.47680892,0.0539979296 C3.47680892,0.0539979296 0.0312993631,6.57507729 0.0312993631,8.64761698 L1.48689172,12.6299662 C1.48689172,12.6299662 0.752388535,19.3191884 1.08773885,20.1949979 C1.42205732,21.0709821 3.74440127,24.0002995 3.74440127,24.0002995 C3.74440127,24.0002995 3.73752229,26.4629027 4.3733121,28.2333789 C4.82698089,29.4976805 5.82649682,30.01049 6.78353503,30.01049 C8.24944586,30.01049 8.82298089,28.6431725 8.82298089,28.6431725 C8.82298089,28.6431725 9.41027389,30.01049 10.8761847,30.01049 C11.833051,30.01049 12.831535,29.4985535 13.2862357,28.2333789 C13.9213376,26.4636011 13.9149745,24.0002995 13.9149745,24.0002995 C13.9149745,24.0002995 16.2368025,21.0709821 16.5718089,20.1949979 C16.9069873,19.3190138 16.1723121,12.6299662 16.1723121,12.6299662 L17.6272166,8.64761698 L17.6272166,8.64761698 Z"
              id="Shape"
              fill="#C49A7E"
            ></path>
            <path
              d="M8.82917197,10.2129344 L8.82315287,10.2253313 L8.82315287,10.1998392 L5.68771338,10.0702836 L4.64210828,8.3242519 L3.47629299,0.0541725328 C3.47629299,0.0541725328 0.0311273885,6.5752519 0.0311273885,8.64779158 L1.4863758,12.6301408 C1.4863758,12.6301408 0.752044586,19.319363 1.08687898,20.1951725 C1.42188535,21.0711567 3.74336943,24.0004741 3.74336943,24.0004741 C3.74336943,24.0004741 3.73735032,26.4630773 4.37245223,28.2335535 C4.82680892,29.4978551 5.82632484,30.0106646 6.78250318,30.0106646 C8.24927389,30.0106646 8.82280892,28.6433471 8.82280892,28.6433471 C8.82280892,28.6433471 8.82538854,28.648236 8.82934395,28.6571408 L8.82934395,10.2129344 L8.82917197,10.2129344 L8.82917197,10.2129344 Z"
              id="Shape"
              fill="#D8B7A0"
            ></path>
          </g>
          <path
            d="M20.8469236,18.0019365 C20.5798471,17.4337778 20.9595669,16.0895079 20.9595669,16.0895079 C18.7839172,13.8222857 18.2397898,9.09455556 18.2397898,9.09455556 C17.833586,10.5842698 16.9506688,14.9765873 16.9506688,14.9765873 C16.9506688,14.9765873 15.3268854,14.3618095 13.479707,14.3588413 L13.479707,14.3588413 L13.473172,14.3588413 L13.465949,14.3588413 L13.465949,14.3588413 C13.3644841,14.3593651 13.2645669,14.3619841 13.1646497,14.3653016 L13.1646497,32.899254 L13.3025732,33.1045873 L13.3025732,33.0031429 L13.3878726,33.0031429 L13.3878726,33.1045873 L13.3887325,33.0031429 L13.5570955,33.0031429 L13.5570955,33.1045873 L13.5570955,33.0031429 L13.6432548,33.0031429 L13.6432548,33.1045873 L15.147172,30.8719365 L15.4740955,24.6026349 L17.3465541,26.774 L19.7586688,27.4903968 C19.7586688,27.4903968 20.6611911,26.8363333 20.6611911,26.8387778 C21.0443503,26.2933175 21.1714395,25.8286984 21.2641338,25.5875714 C21.5991401,24.7103651 20.8469236,18.0019365 20.8469236,18.0019365 L20.8469236,18.0019365 Z"
            id="Shape-Copy-36"
            fill="#3B3B63"
          ></path>
          <path
            d="M13.4893376,14.3586667 C13.4869299,14.3586667 13.4850382,14.3584921 13.4829745,14.3584921 L13.4829745,14.3586667 C11.6351083,14.3618095 10.0111529,14.9762381 10.0111529,14.9762381 C10.0111529,14.9762381 9.12789172,10.5840952 8.72203185,9.09420635 C8.72203185,9.09420635 8.17824841,13.8219365 6.00225478,16.0891587 C6.00225478,16.0891587 6.38197452,17.4336032 6.11489809,18.0015873 C6.11489809,18.0015873 5.36268153,24.7103651 5.6976879,25.5861746 C5.79021019,25.8274762 5.91833121,26.2919206 6.30097452,26.837381 C6.30097452,26.8349365 7.20401274,27.4891746 7.20401274,27.4891746 L9.61561146,26.7726032 L11.4877261,24.6015873 L11.8155096,30.8708889 L13.3185669,33.1035397 L13.3185669,33.0020952 L13.4047261,33.0020952 L13.4047261,33.1035397 L13.4047261,33.0020952 L13.4891656,33.0020952 L13.4891656,14.3586667 L13.4893376,14.3586667 L13.4893376,14.3586667 Z"
            id="Shape-Copy-35"
            fill="#53537A"
          ></path>
          <g id="Group-Copy-10" transform="translate(8.171618, 22.174603)">
            <g id="Group" transform="translate(6.790165, 0.000000)">
              <path
                d="M2.8876242,0.0235714286 L2.8876242,0.0235714286 L0.774057325,0.0235714286 L0.774057325,0.0235714286 L0.0696496815,0.0235714286 L0.0696496815,0.0537777778 C0.0696496815,1.05320635 0.920579618,1.86284127 1.91871975,1.86284127 C2.91720382,1.86284127 3.76813376,1.05303175 3.76813376,0.0537777778 L3.76813376,0.0235714286 L2.8876242,0.0235714286 L2.8876242,0.0235714286 Z"
                id="Shape"
                fill="#333152"
              ></path>
              <path
                d="M0.774057325,0.0235714286 L0.774057325,0.0537777778 C0.774057325,0.648301587 1.24526752,1.13003175 1.83101274,1.13003175 C2.41675796,1.13003175 2.88779618,0.648301587 2.88779618,0.0537777778 L2.88779618,0.0235714286 L0.774057325,0.0235714286 L0.774057325,0.0235714286 Z"
                id="Shape"
                fill="#FFFFFF"
              ></path>
              <path
                d="M2.15707643,0.0235714286 L1.66178981,0.0235714286 C1.65697452,0.0235714286 1.65284713,0.026015873 1.64854777,0.0268888889 C1.70994268,0.039984127 1.74399363,0.181412698 1.73075159,0.27552381 C1.71097452,0.419396825 1.59024841,0.519269841 1.45198089,0.521714286 C1.49222293,0.709761905 1.64321656,0.860968254 1.84373885,0.889603175 C2.09998089,0.926444444 2.33678981,0.748 2.37307643,0.488015873 C2.39921656,0.296650794 2.30858599,0.0235714286 2.15707643,0.0235714286 L2.15707643,0.0235714286 Z"
                id="Shape"
                fill="#333152"
              ></path>
            </g>
            <g id="Group">
              <path
                d="M2.87533708,0.0235714286 L2.87533708,0.0235714286 L0.762114147,0.0235714286 L0.762114147,0.0235714286 L0.057534529,0.0235714286 L0.057534529,0.0537777778 C0.057534529,1.05320635 0.90863644,1.86284127 1.90660459,1.86284127 C2.90508867,1.86284127 3.75619058,1.05303175 3.75619058,0.0537777778 L3.75619058,0.0235714286 L2.87533708,0.0235714286 L2.87533708,0.0235714286 Z"
                id="Shape"
                fill="#333152"
              ></path>
              <path
                d="M0.762114147,0.0235714286 L0.762114147,0.0537777778 C0.762114147,0.648301587 1.23366829,1.13003175 1.81855364,1.13003175 C2.40447083,1.13003175 2.87550905,0.648301587 2.87550905,0.0537777778 L2.87550905,0.0235714286 L0.762114147,0.0235714286 L0.762114147,0.0235714286 Z"
                id="Shape"
                fill="#FFFFFF"
              ></path>
              <path
                d="M2.14513326,0.0235714286 L1.64933071,0.0235714286 C1.64503134,0.0235714286 1.64038803,0.026015873 1.63643262,0.0268888889 C1.69765555,0.039984127 1.73153453,0.181412698 1.71863644,0.27552381 C1.6986874,0.419396825 1.57864918,0.519269841 1.43952179,0.521714286 C1.48027975,0.709761905 1.63127338,0.860968254 1.83145173,0.889603175 C2.08752179,0.926444444 2.32484663,0.748 2.36061733,0.488015873 C2.38710141,0.296650794 2.29664281,0.0235714286 2.14513326,0.0235714286 L2.14513326,0.0235714286 Z"
                id="Shape"
                fill="#333152"
              ></path>
            </g>
          </g>
          <path
            d="M17.6368471,21.3450635 C17.7551656,21.2134127 18.7596688,20.0561429 17.4162038,20.0561429 C16.2022357,20.0561429 15.3287771,21.0506825 15.0972994,21.3450635 L17.6368471,21.3450635 L17.6368471,21.3450635 Z"
            id="Shape-Copy-34"
            fill="#C49A7E"
          ></path>
          <path
            d="M11.8419936,21.3450635 C11.6106879,21.0506825 10.7372293,20.0561429 9.5229172,20.0561429 C8.18014013,20.0561429 9.18464331,21.2134127 9.30227389,21.3450635 L11.8419936,21.3450635 L11.8419936,21.3450635 Z"
            id="Shape-Copy-33"
            fill="#D8B7A0"
          ></path>
          <rect
            id="Rectangle-path-Copy-3"
            fill="#53537A"
            x="7.58098089"
            y="21.6968889"
            width="5.13911465"
            height="0.490634921"
          ></rect>
          <path
            d="M22.9572229,13.6447143 C22.9572229,11.4557143 19.798051,5.39698413 19.4370764,4.7132381 L18.4270701,2.79365079 L16.9802484,13.0749841 L16.3124713,14.191746 C15.6677389,13.9719206 14.5705414,13.6651429 13.4657771,13.6651429 C12.3622166,13.6651429 11.272414,13.970873 10.6304331,14.1910476 L9.9623121,13.0748095 L9.45447134,9.4708254 C9.45515924,9.46488889 9.45601911,9.45685714 9.45601911,9.45319048 L9.45206369,9.45266667 L8.51325478,2.79365079 L7.48192357,4.7132381 C7.12043312,5.39698413 3.93598089,11.4557143 3.93598089,13.6447143 L3.93598089,13.7732222 L5.39415287,17.7168095 C5.16095541,19.8670476 4.71588535,24.5376825 5.06550955,25.4505079 C5.28340127,26.0212857 6.12194904,27.1998571 6.83117197,28.1444603 L5.8758535,37.1845397 L7.19111465,38.1266984 L7.88623567,31.550619 C7.98615287,32.1901905 8.13353503,32.8655556 8.35228662,33.475619 C8.65392994,34.3163333 9.18705096,34.9527619 9.86944586,35.3304286 C9.91003185,37.3430794 11.7522229,38.4284127 13.4877898,38.4284127 C15.2090828,38.4284127 17.0359682,37.3422063 17.0758662,35.3288571 C17.7568854,34.9518889 18.2893185,34.3154603 18.5906178,33.475619 C18.8184841,32.8411111 18.9679299,32.1344921 19.0673312,31.472746 L19.7665796,38.0725714 L21.0818408,37.0968889 L20.1289299,28.1172222 C20.8326497,27.1768095 21.6553758,26.0155238 21.8712038,25.4510317 C22.220828,24.538381 21.7577006,19.8670476 21.5248471,17.7171587 L22.957051,13.7730476 L22.957051,13.6447143 L22.9572229,13.6447143 Z M5.38349045,13.528254 C5.46328662,12.3928095 6.62669427,9.67231746 7.73644586,7.37960317 L8.03224204,9.47588889 C7.91942675,10.2596825 7.40384713,13.3335714 6.02082803,15.2711429 L5.38349045,13.528254 L5.38349045,13.528254 Z M13.4877898,36.9973651 C12.7144204,36.9973651 11.6148153,36.6472857 11.3412038,35.7192698 C11.3692357,35.7201429 11.3967516,35.7225873 11.4252994,35.7225873 C11.5747452,35.7225873 11.7149045,35.708619 11.8502484,35.6890635 C12.2425223,36.2436032 12.8535478,36.4136667 13.4726561,36.4136667 C14.0927962,36.4136667 14.7050255,36.2451746 15.0979873,35.6897619 C15.2324713,35.7084444 15.3710828,35.7225873 15.5193248,35.7225873 C15.5483885,35.7225873 15.5764204,35.7201429 15.6054841,35.7192698 C15.3346242,36.6472857 14.2496369,36.9973651 13.4877898,36.9973651 L13.4877898,36.9973651 Z M12.595586,35.4720317 C12.7837261,35.387 12.9536369,35.2857302 13.1034268,35.1743333 C13.2403185,35.2151905 13.371707,35.2151905 13.4724841,35.2151905 C13.5727452,35.2151905 13.702758,35.2160635 13.8386178,35.1752063 C13.9887516,35.2857302 14.1590064,35.387 14.3471465,35.4720317 C14.1111975,35.6511746 13.8205605,35.7519206 13.473172,35.7519206 C13.1238917,35.7519206 12.831879,35.651873 12.595586,35.4720317 L12.595586,35.4720317 Z M20.5583503,24.9329841 C20.3542166,25.4653492 18.9450573,27.3674762 18.009,28.5484921 L17.8528471,28.7464921 L17.853535,28.9991429 C17.853535,29.0220159 17.8528471,31.3534921 17.2672739,32.9851587 C16.8438726,34.1644286 15.9035159,34.2918889 15.5193248,34.2918889 C14.5466369,34.2918889 14.1268471,33.3865714 14.1120573,33.3539206 L14.0565096,32.505873 L12.8740127,32.505873 L12.8207006,33.3490317 C12.8038471,33.3874444 12.3943758,34.289619 11.4265032,34.289619 C11.0414522,34.289619 10.1014395,34.1635556 9.67769427,32.9842857 C9.09401274,31.358381 9.09126115,29.0220159 9.09126115,28.9982698 L9.09212102,28.745619 L8.93596815,28.5484921 C8.00042675,27.3683492 6.59109554,25.4662222 6.39212102,24.9467778 C6.23304459,24.3849048 6.49564968,20.7514127 6.82996815,17.7066825 L6.84836943,17.5376667 L6.58456051,16.8167302 C7.49086624,15.8520476 8.12682803,14.5243651 8.56553503,13.2605873 L8.60818471,13.5682381 L10.0476115,15.9697302 L10.6099682,15.7245873 C10.6240701,15.7184762 12.0662484,15.0954921 13.4666369,15.0954921 C14.8580828,15.0954921 16.3239936,15.719 16.3377516,15.7251111 L16.8992484,15.9681587 L18.3369554,13.5677143 L18.3933631,13.1668254 C18.8274268,14.443 19.4627006,15.7944286 20.3733057,16.7805873 L20.0971146,17.5371429 L20.1155159,17.7059841 C20.4496624,20.7514127 20.7122675,24.3849048 20.5583503,24.9329841 L20.5583503,24.9329841 Z M20.9399618,15.2299365 C19.4456752,13.0969841 18.9768726,9.62953968 18.9362866,9.31263492 L19.2088662,7.37977778 C20.3184459,9.67231746 21.4825414,12.3929841 21.5623376,13.5284286 L20.9399618,15.2299365 L20.9399618,15.2299365 Z"
            id="Shape-Copy-32"
            fill="#333152"
          ></path>
          <g id="Group-Copy-9" transform="translate(11.350318, 30.031746)">
            <path
              d="M3.78051592,0.0174603175 L0.474821656,0.0174603175 C0.474821656,0.0174603175 0.0302675159,0.804222222 0.0302675159,1.05949206 C0.0302675159,1.81761905 2.06489809,3.02465079 2.06489809,3.02465079 C2.06489809,3.02465079 4.21406369,1.78165079 4.21406369,1.05949206 C4.21406369,0.715 3.78051592,0.0174603175 3.78051592,0.0174603175 L3.78051592,0.0174603175 Z"
              id="Shape"
              fill="#333152"
            ></path>
            <g id="Group" transform="translate(0.859873, 2.011732)">
              <path
                d="M2.28347771,0.316775707 C2.09912102,-0.0151449275 1.86110828,-0.0757322291 1.75190446,0.180236025 C1.64304459,0.436378882 1.70529936,0.913045549 1.88965605,1.24426777 C2.07401274,1.57636301 2.31219745,1.63695031 2.42088535,1.38080745 C2.53008917,1.1248392 2.46817834,0.64799793 2.28347771,0.316775707 L2.28347771,0.316775707 Z"
                id="Shape"
                fill="#C49A7E"
              ></path>
              <path
                d="M0.24110828,0.316775707 C0.0564076433,0.64799793 -0.00498726115,1.1248392 0.103700637,1.38080745 C0.21256051,1.63695031 0.450229299,1.57636301 0.63544586,1.24426777 C0.819802548,0.913220152 0.881541401,0.436378882 0.77233758,0.180236025 C0.663649682,-0.0757322291 0.425808917,-0.0151449275 0.24110828,0.316775707 L0.24110828,0.316775707 Z"
                id="Shape"
                fill="#D8B7A0"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const ArgoCdIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 40 40" xmlSpace="preserve">
    <g>
      <g>
        <g>
          <path
            fill="#E9654B"
            d="M16,27.7c0,0-0.2,0.6-0.5,0.9c-0.2,0.2-0.4,0.3-0.7,0.3c-0.7,0.2-1.5,0.3-1.5,0.3s0.7,0.1,1.5,0.2
				c0.3,0,0.3,0,0.5,0.1c0.5,0,0.7-0.3,0.7-0.3V27.7z"
          />
        </g>
        <g>
          <path
            fill="#E9654B"
            d="M25.2,27.7c0,0,0.2,0.6,0.5,0.9c0.2,0.2,0.4,0.3,0.7,0.3c0.7,0.2,1.5,0.3,1.5,0.3s-0.7,0.1-1.6,0.2
				c-0.3,0-0.3,0-0.5,0.1c-0.6,0-0.7-0.3-0.7-0.3L25.2,27.7z"
          />
        </g>
      </g>
      <g>
        <g>
          <circle fill="#B6CFEA" cx="20.7" cy="17.8" r="10.8" />
        </g>
        <g>
          <circle fill="#E6F5F8" cx="20.7" cy="17.8" r="10.4" />
        </g>
        <g>
          <circle fill="#D0E8F0" cx="20.7" cy="18" r="8.5" />
        </g>
        <g id="Body_1_">
          <g>
            <path
              fill="#EE794B"
              d="M15.7,22c0,0,0.7,11.3,0.7,11.5c0,0.1,0.1,0.3-0.4,0.5s-2.1,0.6-2.1,0.6s1.2,0,2.4,0c1.1,0,1.1-0.9,1.1-1.1
					s0.3-4.5,0.3-4.5s0.1,5.1,0.1,5.3S17.7,34.8,17,35c-0.5,0.1-2,0.4-2,0.4s1.7,0,2.3,0c1.4,0,1.4-0.9,1.4-0.9L19,30
					c0,0,0.1,4.5,0.1,5c0,0.4-0.3,0.7-1.4,0.9c-0.7,0.2-1.6,0.4-1.6,0.4s1.9,0,2.6,0c1.3-0.1,1.5-1,1.5-1l2.2-11.2L15.7,22z"
            />
          </g>
          <g>
            <path
              fill="#EE794B"
              d="M25.7,22c0,0-0.7,11.3-0.7,11.5c0,0.1-0.1,0.3,0.4,0.5s2.1,0.6,2.1,0.6s-1.2,0-2.4,0
					c-1.1,0-1.1-0.9-1.1-1.1S23.7,29,23.7,29s-0.1,5.1-0.1,5.3s0.1,0.5,0.8,0.7c0.5,0.1,2,0.4,2,0.4s-1.7,0-2.3,0
					c-1.4,0-1.4-0.9-1.4-0.9L22.4,30c0,0-0.1,4.5-0.1,5c0,0.4,0.3,0.7,1.4,0.9c0.7,0.2,1.6,0.4,1.6,0.4s-1.9,0-2.6,0
					c-1.3-0.1-1.5-1-1.5-1L19,24.1L25.7,22z"
            />
          </g>
          <g>
            <path
              fill="#EE794B"
              d="M25.8,16.5c0,2.8-2.3,5-5,5s-5-2.3-5-5s2.3-5,5-5S25.8,13.7,25.8,16.5z"
            />
          </g>
          <g>
            <g>
              <defs>
                <polyline
                  id="SVGID_1_"
                  points="25.8,16.3 25.2,30 16.2,30 15.7,16.3 						"
                />
              </defs>
              <clipPath id="SVGID_2_">
                <use href="#SVGID_1_" overflow={'visible'} />
              </clipPath>
              <g clipPath="url(#SVGID_2_)">
                <circle fill="#EE794B" cx="20.8" cy="19.2" r="8.9" />
              </g>
            </g>
          </g>
          <g opacity="0.22">
            <path
              fill="#E34E3B"
              d="M25.5,22c0,0,0.6-5.3-0.2-7.3c-1.5-3.5-5-3.2-5-3.2s2,0.8,2.1,3.8c0.1,2.1,0,5.2,0,5.2L25.5,22z"
            />
          </g>
        </g>
        <g id="Face_1_">
          <g opacity="0.5">
            <g>
              <circle fill="#FBDFC3" cx="18.7" cy="13.8" r="0.7" />
            </g>
          </g>
          <g>
            <g>
              <g>
                <path
                  fill="#010101"
                  d="M22.5,24c0,1.7-0.8,2.8-1.8,2.8s-1.8-1.3-1.8-3c0,0,0.8,1.6,1.9,1.6S22.5,24,22.5,24z"
                />
              </g>
              <g>
                <path
                  fill="#FFFFFF"
                  d="M22.5,24c0,1.1-0.8,1.7-1.8,1.7S19,24.9,19,23.9c0,0,0.8,1,1.9,1S22.5,24,22.5,24z"
                />
              </g>
            </g>
            <g>
              <g>
                <g>
                  <g>
                    <circle fill="#E9654B" cx="24.2" cy="19.3" r="3.1" />
                  </g>
                  <g>
                    <circle fill="#E9654B" cx="17.2" cy="19.3" r="3.1" />
                  </g>
                </g>
                <g>
                  <g>
                    <circle fill="#FFFFFF" cx="24.2" cy="19.3" r="2.4" />
                  </g>
                  <g>
                    <circle fill="#FFFFFF" cx="17" cy="19.3" r="2.4" />
                  </g>
                </g>
              </g>
              <g>
                <g>
                  <circle fill="#010101" cx="17" cy="19" r="0.7" />
                </g>
                <g>
                  <circle fill="#010101" cx="24.2" cy="19" r="0.7" />
                </g>
              </g>
            </g>
          </g>
        </g>
        <g>
          <path
            fill="#B6CFEA"
            d="M9.7,20.5L9.7,20.5c-0.3,0-0.5-0.2-0.5-0.5V16c0-0.3,0.2-0.5,0.5-0.5l0,0c0.3,0,0.5,0.2,0.5,0.5V20
				C10.2,20.3,10,20.5,9.7,20.5z"
          />
        </g>
        <g>
          <path
            fill="#B6CFEA"
            d="M31.5,20.5L31.5,20.5c-0.3,0-0.5-0.2-0.5-0.5V16c0-0.3,0.2-0.5,0.5-0.5l0,0c0.3,0,0.5,0.2,0.5,0.5V20
				C32,20.3,31.8,20.5,31.5,20.5z"
          />
        </g>
        <g>
          <circle fill="#FFFFFF" cx="17.3" cy="9.8" r="0.5" />
        </g>
        <g>
          <path
            fill="#FFFFFF"
            d="M13.7,23.3c-0.1,0-0.2,0-0.3-0.1c-1.2-1.5-1.8-3.4-1.8-5.3c0-1.6,0.4-3.1,1.2-4.5c0.8-1.3,1.9-2.4,3.2-3.2
				c0.2-0.1,0.4,0,0.5,0.1c0.1,0.2,0,0.4-0.1,0.5c-2.5,1.4-4.1,4.1-4.1,7c0,1.8,0.6,3.5,1.7,4.9c0.1,0.1,0.1,0.4-0.1,0.5
				C13.8,23.3,13.8,23.3,13.7,23.3z"
          />
        </g>
        <g opacity="0.25">
          <path
            fill="#E9654B"
            d="M25.2,28v-0.8c-1.4,0.8-2.9,1.6-4.7,1.6c-2,0-3.3-0.9-4.6-1.6L16,28c0,0,1.5,1.6,4.6,1.6
				C23.5,29.5,25.2,28,25.2,28z"
          />
        </g>
      </g>
    </g>
  </SvgIcon>
);

export const MiroIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 320 320" fill="none">
    <g clip-path="url(#a)">
      <path
        fill="#FD3"
        d="M0 80C0 35.817 35.817 0 80 0h160c44.183 0 80 35.817 80 80v160c0 44.183-35.817 80-80 80H80c-44.183 0-80-35.817-80-80V80Z"
      />
      <path
        fill="#1C1C1E"
        fill-rule="evenodd"
        d="M211.878 61h-28.976l24.147 42.425L153.927 61h-28.976l26.561 51.854L95.976 61H67l28.976 66.004L67 259h28.976l55.536-141.425L124.951 259h28.976l53.122-150.854L182.902 259h28.976L265 93.996 211.878 61Z"
        clip-rule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h876v320H0z" />
      </clipPath>
    </defs>
  </SvgIcon>
);

export const HarborIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 345 345">
    <defs>
      <linearGradient
        id="linear-gradient"
        x1="264.79"
        x2="267.27"
        y1="952.39"
        y2="952.39"
        gradientTransform="matrix(30.43 0 0 -30.43 -7955.22 29285.75)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#60b932" />
        <stop offset=".28" stop-color="#60b932" />
        <stop offset="1" stop-color="#367c34" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-2"
        x1="263.77"
        x2="266.26"
        y1="955.65"
        y2="955.65"
        gradientTransform="matrix(27.21 0 0 -27.21 -7073.85 26169.41)"
        href="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-3"
        x1="263.28"
        x2="265.76"
        y1="953.74"
        y2="953.74"
        gradientTransform="matrix(25.75 0 0 -25.75 -6671.13 24812.23)"
        href="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-4"
        x1="263.77"
        x2="266.25"
        y1="953.2"
        y2="953.2"
        gradientTransform="matrix(27.1 0 0 -27.1 -7040.9 26102.49)"
        href="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-5"
        x1="262.73"
        x2="265.21"
        y1="954.34"
        y2="954.34"
        gradientTransform="matrix(24.4 0 0 -24.4 -6301.36 23521.97)"
        href="#linear-gradient"
      />
      <linearGradient
        id="linear-gradient-6"
        x1="272.14"
        x2="274.62"
        y1="955.15"
        y2="955.15"
        gradientTransform="scale(66.09 -66.09) rotate(36.52 1588.153 68.148)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#4596d8" />
        <stop offset=".2" stop-color="#4596d8" />
        <stop offset="1" stop-color="#fff" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-7"
        x1="270.65"
        x2="273.13"
        y1="952.38"
        y2="952.38"
        gradientTransform="scale(77.8 -77.8) rotate(-11.54 -4587.209 1803.323)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#4194d7" />
        <stop offset=".2" stop-color="#4194d7" />
        <stop offset="1" stop-color="#fff" />
      </linearGradient>
      <linearGradient
        id="linear-gradient-8"
        x1="270.97"
        x2="273.45"
        y1="953.75"
        y2="953.75"
        gradientTransform="scale(71.35 -71.35) rotate(10.23 5477.37 -1024.602)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#4194d7" />
        <stop offset=".33" stop-color="#4496d8" />
        <stop offset="1" stop-color="#fff" />
      </linearGradient>
      <clipPath id="clip-path">
        <path
          d="M174.4 302.52l-68.65-30.26-3.83 43.21 75.5 23.98-3.02-36.93z"
          fill="none"
        />
      </clipPath>
      <clipPath id="clip-path-2">
        <path
          d="M119.19 135.38h38.55v32.89h-9.15v-14a10.13 10.13 0 1 0-20.26 0v14h-9.15zm-7.7 72l57.2 25.21-3.94-48.24h7.49v-16.08h-5.55v-32.89h5.55v-9.45l-30.86-30.19v-2.12a2.91 2.91 0 0 0-5.82 0v2.12l-30.86 30.19v9.45h5.56v32.89h-5.56v16.12h8.82z"
          fill="none"
        />
      </clipPath>
      <clipPath id="clip-path-3">
        <path
          d="M108.14 245.28l63.88 28.16-.96-11.73-61.96-27.3-.96 10.87z"
          fill="none"
        />
      </clipPath>
      <clipPath id="clip-path-4">
        <path
          d="M106.46 264.21l67.23 29.63-.96-11.72-65.31-28.78-.96 10.87z"
          fill="none"
        />
      </clipPath>
      <clipPath id="clip-path-5">
        <path
          d="M110.77 215.48l-.96 10.87 60.54 26.68-.95-11.72-58.63-25.83z"
          fill="none"
        />
      </clipPath>
      <clipPath id="clip-path-6">
        <path
          d="M313.13 67.59a175.31 175.31 0 0 0-29.75-28.13c-1.57-1.17-3.18-2.3-4.79-3.42L256 59.5l-82.34 85.63 113.41-58.68 29.07-15c-1.01-1.31-1.98-2.62-3.01-3.86z"
          fill="none"
        />
      </clipPath>
      <clipPath id="clip-path-7">
        <path
          d="M353.59 177.61c0-2-.14-4-.22-5.93l-32.21-2.31-147.47-10.58L318.36 209l30.41 10.55c.09-.36.19-.71.28-1.08a173.65 173.65 0 0 0 4.57-39.47v-1.37z"
          fill="none"
        />
      </clipPath>
      <clipPath id="clip-path-8">
        <path
          d="M348.84 138.61a172.55 172.55 0 0 0-13.84-37.7l-30.94 9.94L175.92 152l142-4.83 32.5-1.11c-.5-2.48-.99-4.98-1.58-7.45z"
          fill="none"
        />
      </clipPath>
    </defs>
    <g id="g12">
      <path
        id="path14"
        fill="#fff"
        d="M30.89 179a148.87 148.87 0 1 1 148.87 148.85A148.87 148.87 0 0 1 30.89 179"
      />
      <g id="g30" clip-path="url(#clip-path)">
        <g id="g32">
          <path
            id="path46"
            fill="url(#linear-gradient)"
            d="M174.4 302.52l-68.65-30.25-3.82 43.2 75.5 24-3-36.93"
          />
        </g>
      </g>
      <g id="g48" clip-path="url(#clip-path-2)">
        <g id="g50">
          <path
            id="path64"
            fill="url(#linear-gradient-2)"
            d="M119.19 135.38h38.55v32.89h-9.15v-14a10.13 10.13 0 1 0-20.26 0v14h-9.15zm-7.7 72l57.2 25.21-3.94-48.24h7.49v-16.08h-5.55v-32.89h5.55v-9.45l-30.86-30.19v-2.12a2.91 2.91 0 0 0-5.82 0v2.12l-30.86 30.19v9.45h5.56v32.89h-5.56v16.12h8.82l-2 23"
          />
        </g>
      </g>
      <g id="g66" clip-path="url(#clip-path-3)">
        <g id="g68">
          <path
            id="path82"
            fill="url(#linear-gradient-3)"
            d="M108.13 245.28L172 273.44l-1-11.72-62-27.31-1 10.87"
          />
        </g>
      </g>
      <g id="g84" clip-path="url(#clip-path-4)">
        <g id="g86">
          <path
            id="path100"
            fill="url(#linear-gradient-4)"
            d="M106.46 264.21l67.23 29.63-1-11.72-65.31-28.78-1 10.87"
          />
        </g>
      </g>
      <g id="g102" clip-path="url(#clip-path-5)">
        <g id="g104">
          <path
            id="path118"
            fill="url(#linear-gradient-5)"
            d="M110.77 215.48l-1 10.88L170.35 253l-1-11.72-58.62-25.83"
          />
        </g>
      </g>
      <path
        id="path120"
        d="M304.07 110.85l30.93-9.94c-.11-.22-.21-.45-.32-.66a174.41 174.41 0 0 0-18.55-28.83l-29.07 15a142.71 142.71 0 0 1 16.73 23.87c.1.17.18.35.27.53"
        fill="#696566"
      />
      <path
        id="path122"
        d="M321.15 169.37l32.21 2.31a172.86 172.86 0 0 0-3-25.59l-32.5 1.11a141 141 0 0 1 3.25 22.17"
        fill="#696566"
      />
      <path
        id="path124"
        d="M182 320.81c-78.2 0-141.83-63.62-141.83-141.82S103.82 37.16 182 37.16a140.93 140.93 0 0 1 76.3 22.34L280.85 36A172.86 172.86 0 0 0 182 5.11C86.15 5.11 8.15 83.11 8.15 179s78 173.85 173.85 173.85c81.9 0 150.69-57 169-133.32L320.62 209c-13.8 63.84-70.69 111.83-138.6 111.83"
        fill="#696566"
      />
      <g id="g126" clip-path="url(#clip-path-6)">
        <g id="g128">
          <path
            id="path142"
            fill="url(#linear-gradient-6)"
            d="M313.13 67.59a175.31 175.31 0 0 0-29.75-28.13c-1.57-1.17-3.18-2.3-4.79-3.42L256 59.5l-82.34 85.63 113.41-58.68 29.07-15c-1-1.27-2-2.58-3-3.82"
          />
        </g>
      </g>
      <g id="g144" clip-path="url(#clip-path-7)">
        <g id="g146">
          <path
            id="path160"
            fill="url(#linear-gradient-7)"
            d="M353.59 177.61c0-2-.14-4-.22-5.93l-32.21-2.31-147.47-10.58L318.36 209l30.41 10.55c.09-.36.19-.71.28-1.08a173.65 173.65 0 0 0 4.57-39.47v-1.37"
          />
        </g>
      </g>
      <g id="g162" clip-path="url(#clip-path-8)">
        <g id="g164">
          <path
            id="path178"
            fill="url(#linear-gradient-8)"
            d="M348.84 138.61a172.55 172.55 0 0 0-13.84-37.7l-30.94 9.94L175.92 152l142-4.83 32.5-1.11c-.48-2.51-1-5-1.56-7.48"
          />
        </g>
      </g>
    </g>
  </SvgIcon>
);
